import { queryBot2 } from 'boot/axios';

function prepareLikes (item) {
    if (!item || typeof item !== 'object') {
        return;
    }
    if (item.likes) {
        item.likes = Object.values(JSON.parse(item.likes));
    }
    if (!item.likes || typeof item.likes !== 'object') {
        item.likes = [];
    }
}

export async function loadProjectByUserId (userId, portfolioId = undefined) {
    return queryBot2(portfolioId ? 'loadProjectByUserId2' : 'loadProjectByUserId1', { userId, portfolioId }).then(async (r) => {
        let project;
        const [result] = r.data;
        // console.log('result >', result);
        if (result && typeof result === 'object') {
            await prepareLikes(result);
            project = result;
        }
        return project;
    });
}

export async function loadProjectByField (key, value) {
    return queryBot2(`loadProjectByField-${key}`, { value }).then(async (r) => {
        let project;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            await prepareLikes(result);
            project = result;
        }
        return project;
    });
}

export async function loadProjectById (id, portfolioId = undefined) {
    return queryBot2(portfolioId ? 'loadProjectById2' : 'loadProjectById1', { id, portfolioId }).then(async (r) => {
        let project;
        const [result] = r.data;
        // console.log('result >', result);
        if (result && typeof result === 'object') {
            await prepareLikes(result);
            project = result;
        }
        return project;
    });
}

export async function loadProjects (portfolioId = undefined) {
    return queryBot2('loadProjects', { portfolioId }).then(async (r) => {
        let projects;
        const result = r.data;
        // console.log('result >', result);
        if (result && typeof result === 'object') {
            projects = {};
            await Object.values(result).forEach(async (i) => {
                await prepareLikes(i);
                projects[i.id] = i;
            });
        }
        return projects;
    });
}

export default loadProjects;
